"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * USCIS Verifications Identity Service
 * An [Oauth 2.0](https://tools.ietf.org/html/rfc6749) compliant API which wraps the [identity providers](https://maestro.dhs.gov/confluence/display/VERST/Identity+Providers) used in the USCIS Verifications ecosystem.
 *
 * The version of the OpenAPI document: 2.4.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAccessTokenGrantTypeEnum = exports.TokenApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var TokenApi = /** @class */ (function (_super) {
    __extends(TokenApi, _super);
    function TokenApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Supports both the [Resource Owner Password Credentials Grant](https://tools.ietf.org/html/rfc6749#section-4.3) and the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1) <br><br> The form field parameters passed depend on the value of the corresponding `grant_type`<br> &emsp;* `password` https://tools.ietf.org/html/rfc6749#section-4.3.2<br> &emsp;* `authorization_code` https://tools.ietf.org/html/rfc6749#section-4.1.3
     * Provides a token to be used for accessing protected resources.
     */
    TokenApi.prototype.getAccessTokenRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.grantType === null || requestParameters.grantType === undefined) {
                            throw new runtime.RequiredError('grantType', 'Required parameter requestParameters.grantType was null or undefined when calling getAccessToken.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.grantType !== undefined) {
                            formParams.append('grant_type', requestParameters.grantType);
                        }
                        if (requestParameters.username !== undefined) {
                            formParams.append('username', requestParameters.username);
                        }
                        if (requestParameters.password !== undefined) {
                            formParams.append('password', requestParameters.password);
                        }
                        if (requestParameters.scope !== undefined) {
                            formParams.append('scope', requestParameters.scope);
                        }
                        if (requestParameters.code !== undefined) {
                            formParams.append('code', requestParameters.code);
                        }
                        if (requestParameters.redirectUri !== undefined) {
                            formParams.append('redirect_uri', requestParameters.redirectUri);
                        }
                        if (requestParameters.clientId !== undefined) {
                            formParams.append('client_id', requestParameters.clientId);
                        }
                        if (requestParameters.refreshToken !== undefined) {
                            formParams.append('refresh_token', requestParameters.refreshToken);
                        }
                        if (requestParameters.codeVerifier !== undefined) {
                            formParams.append('code_verifier', requestParameters.codeVerifier);
                        }
                        if (requestParameters.state !== undefined) {
                            formParams.append('state', requestParameters.state);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/token",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.TokenResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Supports both the [Resource Owner Password Credentials Grant](https://tools.ietf.org/html/rfc6749#section-4.3) and the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1) <br><br> The form field parameters passed depend on the value of the corresponding `grant_type`<br> &emsp;* `password` https://tools.ietf.org/html/rfc6749#section-4.3.2<br> &emsp;* `authorization_code` https://tools.ietf.org/html/rfc6749#section-4.1.3
     * Provides a token to be used for accessing protected resources.
     */
    TokenApi.prototype.getAccessToken = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccessTokenRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a VIS JWT for an Apigee Developer given its configuration data within the Apigee platform.
     * Provides Apigee a way to retrieve an identity service token (VIS JWT) on behalf of its client applications.
     */
    TokenApi.prototype.getApigeeTokenRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.apigeeTokenRequest === null || requestParameters.apigeeTokenRequest === undefined) {
                            throw new runtime.RequiredError('apigeeTokenRequest', 'Required parameter requestParameters.apigeeTokenRequest was null or undefined when calling getApigeeToken.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/apigee-token",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ApigeeTokenRequestToJSON(requestParameters.apigeeTokenRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ApigeeTokenResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a VIS JWT for an Apigee Developer given its configuration data within the Apigee platform.
     * Provides Apigee a way to retrieve an identity service token (VIS JWT) on behalf of its client applications.
     */
    TokenApi.prototype.getApigeeToken = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApigeeTokenRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Logs user in with vis jwt if the user is associated with the provided dashboard jwt. >  Validation Error Codes:   * `USER_NOT_PRESENT`   * `INVALID_TOKEN`
     * Endpoint for users to use a dashboard jwt as a means to login and obtain a vis jwt
     */
    TokenApi.prototype.putLoginUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling putLoginUser.');
                        }
                        if (requestParameters.loginUserRequest === null || requestParameters.loginUserRequest === undefined) {
                            throw new runtime.RequiredError('loginUserRequest', 'Required parameter requestParameters.loginUserRequest was null or undefined when calling putLoginUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/login-user/{user_id}".replace("{" + "user_id" + "}", encodeURIComponent(String(requestParameters.userId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.LoginUserRequestToJSON(requestParameters.loginUserRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.TokenResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Logs user in with vis jwt if the user is associated with the provided dashboard jwt. >  Validation Error Codes:   * `USER_NOT_PRESENT`   * `INVALID_TOKEN`
     * Endpoint for users to use a dashboard jwt as a means to login and obtain a vis jwt
     */
    TokenApi.prototype.putLoginUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putLoginUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Supports swapping the old eve-oauth2-provider token for a new identity service token provided that the token has not expired. This endpoint is to support Save and EV-Star during the transition off of oracle and should be removed afterwards.
     * Swaps a valid token from the eve-oauth2-provider service for an identity service token.
     */
    TokenApi.prototype.swapEveOauth2TokenRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
                            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling swapEveOauth2Token.');
                        }
                        if (requestParameters.tokenSwapRequest === null || requestParameters.tokenSwapRequest === undefined) {
                            throw new runtime.RequiredError('tokenSwapRequest', 'Required parameter requestParameters.tokenSwapRequest was null or undefined when calling swapEveOauth2Token.');
                        }
                        queryParameters = {};
                        if (requestParameters.clientId !== undefined) {
                            queryParameters['client_id'] = requestParameters.clientId;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/token-swap",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.TokenSwapRequestToJSON(requestParameters.tokenSwapRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.TokenResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Supports swapping the old eve-oauth2-provider token for a new identity service token provided that the token has not expired. This endpoint is to support Save and EV-Star during the transition off of oracle and should be removed afterwards.
     * Swaps a valid token from the eve-oauth2-provider service for an identity service token.
     */
    TokenApi.prototype.swapEveOauth2Token = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.swapEveOauth2TokenRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TokenApi;
}(runtime.BaseAPI));
exports.TokenApi = TokenApi;
/**
    * @export
    * @enum {string}
    */
var GetAccessTokenGrantTypeEnum;
(function (GetAccessTokenGrantTypeEnum) {
    GetAccessTokenGrantTypeEnum["Password"] = "password";
    GetAccessTokenGrantTypeEnum["AuthorizationCode"] = "authorization_code";
    GetAccessTokenGrantTypeEnum["RefreshToken"] = "refresh_token";
})(GetAccessTokenGrantTypeEnum = exports.GetAccessTokenGrantTypeEnum || (exports.GetAccessTokenGrantTypeEnum = {}));
